import { useState } from 'react';
import PropTypes from 'prop-types';
import { useLogin } from '../../context/LoginContext';
import { useI18n } from '../../context/I18nContext';
import SettingsButton from './SettingsButton';
import ChatsIcon from './Icons/Chats';
import RoomsIcon from './Icons/Rooms';
import PeopleIcon from './Icons/People';
import './Menu.css';

const MenuItem = ({
  icon: Icon,
  label = '',
  isActive = false,
  onClick = () => {},
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`menu-item ${isActive || isHovered ? 'active' : ''}`}
      onClick={onClick}
      title={label}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="menu-item-icon">
        {Icon && <Icon size={30} />}
      </div>
      <div className="menu-item-label">{label}</div>
    </div>
  );
};

MenuItem.propTypes = {
  icon: PropTypes.elementType,
  label: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};

const Menu = ({
  currentPage = '',
  onSettingsClick = () => {},
  setToConversations = () => {},
  setToContacts = () => {},
  setToChannels = () => {},
}) => {
  const { currentUser } = useLogin();
  const { t } = useI18n();

  return (
    <div className="menu">
      <SettingsButton onClick={onSettingsClick} user={currentUser} />
      <div className="menu-divider" />
      <MenuItem icon={ChatsIcon} label={t('Menu.chats')} isActive={currentPage === 'conversations'} onClick={setToConversations} />
      <MenuItem icon={RoomsIcon} label={t('Menu.rooms')} isActive={currentPage === 'channels'} onClick={setToChannels} />
      <MenuItem icon={PeopleIcon} label={t('Menu.people')} isActive={currentPage === 'contacts'} onClick={setToContacts} />
      <div className="menu-divider" />
      <div className="menu-logo">
        <img src="/images/NetSfere_TI.svg" alt="NetSfere" title="NetSfere" />
      </div>
    </div>
  );
};

Menu.propTypes = {
  currentPage: PropTypes.string,
  onSettingsClick: PropTypes.func,
  setToConversations: PropTypes.func,
  setToContacts: PropTypes.func,
  setToChannels: PropTypes.func,
};

export default Menu;
